export default __webpack_public_path__ + "static/desktop_landing-8675864222b51a5bfd72e81bcff85daa.png";